import {
    getElement,
    getElements,
    ifSelectorExist,
    slideDown,
    slideUp,
    slideToggle,
} from "./utils";
import {
    storiesSlider,
    testimonialSlider,
    caseSlider,
    lifeSlider,
} from "./sliders";
import { modalDialog } from "./modals";
import { cardFlipOnClick, cardFlipOnSafari } from "./_card-flip-safari";
testimonialSlider();

storiesSlider();
lifeSlider();

let secondStep = () => {
    let btnForm = getElement(".send_form_btn");
    let firstStep = getElement(".form_disclaimer_first_step");
    let secondStep = getElement(".form_disclaimer_second_step");
    let nextStep = getElement(".next_step span");

    if (ifSelectorExist(nextStep)) {
        nextStep.addEventListener("click", () => {
            firstStep.style.display = "none";
            secondStep.classList.remove("hidden");
            btnForm.classList.remove("hidden-btn");
            nextStep.style.display = "none";
        });
    }
};
secondStep();

let showText = () => {
    let btn = document.querySelector(".btn-more-here");
    let hiddenPart = document.querySelector(".hidden-text");

    if (ifSelectorExist(btn) && ifSelectorExist(hiddenPart)) {
        btn.addEventListener("click", () => {
            event.preventDefault();
            hiddenPart.classList.toggle("hidden-text");

            if (!hiddenPart.classList.contains("hidden-text")) {
                btn.textContent = "- show less";
                hiddenPart.classList.remove("hidden");
            } else {
                btn.textContent = "+ read more";
                hiddenPart.classList.add("hidden");
            }
        });
    }
};
showText();

let faq = () => {
    const acc = getElements(".faq__header");
    if (acc && acc.length) {
        for (let i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                if (
                    this.parentNode.classList.contains("faq__position__active")
                ) {
                    this.nextElementSibling.style.maxHeight = null;
                    this.parentNode.classList.remove("faq__position__active");
                } else {
                    for (let j = 0; j < acc.length; j++) {
                        acc[j].parentNode.classList.remove(
                            "faq__position__active"
                        );
                        acc[j].nextElementSibling.style.maxHeight = null;
                    }
                    this.parentNode.classList.add("faq__position__active");
                    const panel = this.nextElementSibling;
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    }
    let moreBtn = getElement(".faq-without-image__btn");
    if (ifSelectorExist(moreBtn)) {
        moreBtn.addEventListener("click", () => {
            let hiddenFaqImageLeft = getElement(".hidden_faq_image_left");
            moreBtn.textContent = "- show less";
            if (moreBtn.classList.contains("clicked")) {
                hiddenFaqImageLeft.classList.add("hidden");
                moreBtn.textContent = "+ more...";
                moreBtn.classList.remove("clicked");
            } else {
                if (ifSelectorExist(hiddenFaqImageLeft)) {
                    moreBtn.classList.add("clicked");
                    hiddenFaqImageLeft.classList.remove("hidden");
                }
            }
        });
    }
};
faq();

var maxLength = 1098;
$(".form-text").each(function () {
    var myStr = $(this).html();
    if (myStr.length > maxLength) {
        let isOpen = false;
        jQuery(this).append('<div id="text-content"></div>');
        jQuery(this).children().appendTo("#text-content");
        $(this).find("#text-content").css("max-height", "580px");
        $(this).find("#text-content").css("margin-bottom", "20px");
        $(this).find("#text-content").css("overflow", "hidden");
        $(this).append('<p class="read-more-case">Read more...</p>');
        //$(this).append('<span class="more-text-case hidden">' + removedStr + '<a href="javascript:void(0);" class="read-less-case block">See less...</a></span>');
        $(".read-more-case").click(function () {
            //$(".more-text-case").toggleClass("hidden open");
            isOpen = !isOpen;
            if (isOpen) {
                $("#text-content").addClass("open");
                $("#text-content").css("max-height", "100%");
                $(this).text("See less...");
            } else {
                $("#text-content").removeClass("open");
                $("#text-content").css("max-height", "580px");
                $(this).text("Read more...");
            }
        });
    }
});

window.addEventListener("DOMContentLoaded", event => {
    caseSlider();
    modalDialog();
    cardFlipOnSafari();
    cardFlipOnClick();
});
